import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import GiveQueryObjReturnValueObj from "../Functions/Query/GiveQueryObjReturnValueObj";

const URL = `${process.env.REACT_APP_BACKEND_HOSTED_ON}${process.env.REACT_APP_END_POINT_SING_UP_EMAIL_VERIFICATION}`;

const { name, token } = GiveQueryObjReturnValueObj(["name", "token"]);

const headers = {};
headers["x-auth-token"] = !token ? "blankToken" : token;

export const sendEmailVerificationRequest = createAsyncThunk(
  "sendEmailVerificationRequest",
  async (userData, thunkApi) => {
    try {
      const request = await axios.post(URL, {}, { headers });
      return request.data;
    } catch (error) {
      if (error.response) {
        return thunkApi.rejectWithValue(error.response.data);
      }
      // Handle network or other errors
      return thunkApi.rejectWithValue("Error occurred");
    }
  }
);

export const EmailVerificationSlice = createSlice({
  name: "EmailVerification",
  initialState: {
    clientName: name,
    response: null,
    success: false,
    loading: false,
    error: null,
  },
  reducers: {
    // * Action given here
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendEmailVerificationRequest.pending, (state) => {
        state.loading = true;
      })
      .addCase(sendEmailVerificationRequest.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.response = action.payload;
        state.error = null;
      })
      .addCase(sendEmailVerificationRequest.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.response = null;
      });
  },
});

// export const {} = EmailVerificationSlice.actions;
export default EmailVerificationSlice.reducer;
